module.exports = __webpack_public_path__ + "static/img/alertWin.32e9e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/alertWin.png
// module id = 2NcE
// module chunks = 1